import { Tabs } from "@mui/material";
import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

import { Layout, Paper, Tab, TabPanel } from "$components";
import useJStyles from "$hooks/useJStyles";
import useTabs from "$hooks/useTabs";
import ShippingConfigList from "./ShippingConfig/ShippingConfigList";
import WMSConfigList from "./WMSConfig/WMSConfigList";

function Configurations() {
  const classes = useStyles();
  const { jclasses } = useJStyles();
  const { currentTab, handleChangeTab } = useTabs();

  return (
    <div className={jclasses.jWrapper}>
      <Layout title="Configurations" contentClassName={jclasses.jLayoutCustom}>
        <Paper className={jclasses.jPaper}>
          <Tabs
            className={classes.tabheader}
            TabIndicatorProps={{
              style: { background: theme.color.blueLight, height: 3 },
            }}
            value={currentTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChangeTab}
            aria-label="Configuration tabs"
          >
            <Tab label="TMS" />
            <Tab label="WMS" />
          </Tabs>
          <TabPanel value={currentTab} index={0}>
            <ShippingConfigList />
          </TabPanel>
          <TabPanel value={currentTab} index={1}>
            <WMSConfigList />
          </TabPanel>
        </Paper>
      </Layout>
    </div>
  );
}

export default Configurations;

const useStyles = createUseStyles(() => ({
  divider: {
    margin: "15px 0 !important",
    display: "block",
  },
  tabheader: {
    borderBottom: `1px solid ${theme.color.gray2}`,
    marginBottom: theme.spacing(2),
  },
}));
